/**
 * EntityDropdownSearch
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';

// Actions
import {
    updateQueryString,
    deleteQueryString
} from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
// @ts-ignore
import { makeSelectEntityTypeValue } from '../../../../services/entityTypes/selectors';
import { selectOptions } from './selectors';

interface OwnProps {
    clearPageOnChange?: boolean;
    multiple?: boolean;
    entityTypeId: string | number;
    showDeletedEntities?: boolean;
    clearable?: boolean;
    singleFilter?: boolean;
    isInnerEntity?: boolean;
}

interface ConnectedProps {
    entities?: string | string[];
    innerEntities?: string | string[];
    pluralName: string;
    options: {
        key: number;
        text: string;
        value: number;
    }[];
}

interface DispatchProps {
    updateQueryString: Function;
    deleteQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class EntityDropdownSearch extends React.Component<Props> {
    static defaultProps = {
        isInnerEntity: false
    };

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        const {
            options,
            entities,
            innerEntities,
            isInnerEntity,
            updateQueryString: updateQueryStringAction
        } = props;

        const dynamicQueryString: {
            [x: string]: any;
        } = {};

        const queryStringName = isInnerEntity ? 'innerEntities' : 'entities';
        const value = isInnerEntity ? innerEntities : entities;

        if (!isEqual(prevProps.options, options)) {
            if (Array.isArray(value)) {
                dynamicQueryString[queryStringName] = value.filter((id) =>
                    options.some((option: any) => option.value === id)
                );
            } else if (
                value &&
                !options.some((option: any) => option.value === value)
            ) {
                dynamicQueryString[queryStringName] = undefined;
            }
        }
        updateQueryStringAction(dynamicQueryString);
    }

    handleChange = (event: any, data: { value: number }): void => {
        const {
            isInnerEntity,
            clearPageOnChange,
            singleFilter,
            deleteQueryString: deleteQueryStringAction,
            updateQueryString: updateQueryStringAction
        } = this.props;

        if (singleFilter) deleteQueryStringAction();

        const dynamicQueryString: {
            [x: string]: any;
        } = {};

        const queryStringName = isInnerEntity ? 'innerEntities' : 'entities';
        dynamicQueryString[queryStringName] = data.value || undefined;

        updateQueryStringAction({
            ...(clearPageOnChange ? { page: undefined } : {}),
            ...dynamicQueryString,
            selectedEvent: undefined
        });
    };

    render(): React.ReactElement {
        const {
            entities,
            innerEntities,
            options,
            multiple,
            pluralName,
            clearable = true
        } = this.props;
        return (
            <Dropdown
                placeholder={`All ${pluralName}`}
                search
                selection
                // @ts-ignore
                value={entities || innerEntities || null}
                clearable={clearable}
                selectOnBlur={false}
                options={options}
                // @ts-ignore
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entities: makeSelectQueryStringValue('entities'),
    innerEntities: makeSelectQueryStringValue('innerEntities'),
    options: selectOptions,
    pluralName: makeSelectEntityTypeValue('pluralName')
});

export default connect(mapStateToProps, {
    updateQueryString,
    deleteQueryString
})(EntityDropdownSearch);
